import { reactive, watch } from "vue";
import { parseDate, checkDayToDay } from "@/utils/changeDate";
import { useDataFormStore } from "@/stores/form";
import { getArrayOfRules } from "@/utils/getDataForm";
import { debounce  } from "@/utils/setDebounce";
import { ref } from "vue";
import { ADDRESS } from "@/remotes";
import { checkCityRoadTo, checkCityRoadFrom } from "@/utils/baseFunctions";
import {
  blockPickupSwitch
} from "@/utils/baseFunctions";
import { refreshTimePickup } from "@/utils/refreshPackages";
import { tabRefreshTimePickup } from "@/utils/tabsFunctions";

const SUNDAY = 0;
const WITH_START_TIME = "09:00";
const BEFORE_START_TIME = "12:00";

// Инициализируем лист адресов забора
const fromAddressList = ref({});
const toAddressList = ref({});
const addressFromDropdown = ref();
const addressToDropdown = ref();

export default {
  props: {
    cities: Array,
  },

  setup() {
    const dataForm = useDataFormStore();

    const options = ["Отправитель", "Получатель", "Третье лицо"];

    const optionsTypePowerOfAttorney = [
      {
        value: 1, //"Luch",
        label: 'ООО "УК ЛУЧ"',
      },
      {
        value: 2, //"Customer",
        label: "От заказчика",
      },
    ];

    // Получаем адреса для  забора с API и подставляем в список (значение, город отправки)
    async function getFromAddressList(value, cityFrom) {
      if (value.length > 1) {
        try {
          let cityQueryData = cityFrom;

          const wordsQueryArray = cityQueryData.includes("(") ? [cityQueryData.split(" (")[0], cityQueryData.split(" (")[1].split(")")[0]] : [cityQueryData];
          const cityQueryObjects = wordsQueryArray.map(city => ({ "city": city }));
          const settlementQueryObjects = wordsQueryArray.map(settlement => ({"settlement": settlement}));
          
          const { data } = await ADDRESS.post('4_1/rs/suggest/address', { query: value, locations: [{"country": "Russia"}, {"country": "Kazahstan"}, ...cityQueryObjects, ...settlementQueryObjects], restrict_value: true });

          data.suggestions.forEach((el) => {
            if(el.data.street_with_type !== null)  {
              el.value = el.data.street_with_type
              if(el.data.house_type !== null)  el.value += ", "+el.data.house_type
              if(el.data.house !== null)  el.value += " "+el.data.house
              if(el.data.flat_type !== null)  el.value += ", "+el.data.flat_type
              if(el.data.flat !== null)  el.value += " "+el.data.flat
              if(el.data.block !== null)  el.value += " стр "+el.data.block
            }
          });

         // В случае появлении скобок
          if(wordsQueryArray.length == 2) {
            const firstWord = wordsQueryArray[0];
            const secondWord = wordsQueryArray[1];
            const resultsFirstWord = data.suggestions.filter(res => res.data.city === firstWord || res.data.settlement === firstWord );
            const resultsSecondWord = data.suggestions.filter(res => (res.data.city === secondWord || res.data.settlement === secondWord && res.data.city != firstWord && res.data.settlement != firstWord));
            const streetsFirstWord = new Set(resultsFirstWord.map(r => r.data.street_with_type));
            const streetsSecondWord = new Set(resultsFirstWord.map(r => r.data.street_with_type));
            let resultsToDelete = resultsSecondWord
              .filter(r => streetsFirstWord.has(r.data.street_with_type))
              .map(r => r.unrestricted_value);
            let resultsToSortUp = resultsFirstWord
              .filter(r => streetsSecondWord.has(r.data.street_with_type))
              .map(r => r.unrestricted_value);

            // Удаляем дубликаты
            data.suggestions = data.suggestions.filter(r => !resultsToDelete.includes(r.unrestricted_value));
            // Сортируем оригиналы вверх
            data.suggestions = data.suggestions.sort((a, b) =>
              resultsToSortUp.includes(a.unrestricted_value) === resultsToSortUp.includes(b.unrestricted_value) ? 0 : resultsToSortUp.includes(a.unrestricted_value) ? -1 : 1
            );
          }
          

          fromAddressList.value = data.suggestions.filter(el => !((el.value == "Россия, г Челябинск") || (el.value == "Россия, г Екатеринбург")));

          if(fromAddressList.value.length < 1) {
            fromAddressList.value[0] = {disabled: "true", class: "disable-notice", value: "Нет результатов"};
          } else {
            fromAddressList.value.unshift({disabled: "true", class: "disable-notice", value: "Выберите нужный адрес"});
          }
        } catch (e) {
          console.log(e);
        }
      }

    }

    // Получаем адреса для получателя с API и подставляем в список (значение, город отправки)
    async function getToAddressList(value, cityTo) {
      if (value.length > 1) {
        try {
          let cityQueryData = cityTo;
          
          const wordsQueryArray = cityQueryData.includes("(") ? [cityQueryData.split(" (")[0], cityQueryData.split(" (")[1].split(")")[0]] : [cityQueryData];
          const cityQueryObjects = wordsQueryArray.map(city => ({ "city": city }));
          const settlementQueryObjects = wordsQueryArray.map(settlement => ({"settlement": settlement}));

          const { data } = await ADDRESS.post('4_1/rs/suggest/address', { query: value, locations: [{"country": "Russia"}, {"country": "Kazahstan"}, ...cityQueryObjects, ...settlementQueryObjects], restrict_value: true });
          
          data.suggestions.forEach(el => {
            if(el.data.street_with_type !== null)  {
              el.value = el.data.street_with_type
              if(el.data.house_type !== null)  el.value += ", "+el.data.house_type
              if(el.data.house !== null)  el.value += " "+el.data.house
              if(el.data.flat_type !== null)  el.value += ", "+el.data.flat_type
              if(el.data.flat !== null)  el.value += " "+el.data.flat
              if(el.data.block !== null)  el.value += " стр "+el.data.block
            }
          });

          // В случае появлении скобок
          if(wordsQueryArray.length == 2) {
            const firstWord = wordsQueryArray[0];
            const secondWord = wordsQueryArray[1];
            const resultsFirstWord = data.suggestions.filter(res => res.data.city === firstWord || res.data.settlement === firstWord );
            const resultsSecondWord = data.suggestions.filter(res => (res.data.city === secondWord || res.data.settlement === secondWord && res.data.city != firstWord && res.data.settlement != firstWord));
            const streetsFirstWord = new Set(resultsFirstWord.map(r => r.data.street_with_type));
            const streetsSecondWord = new Set(resultsFirstWord.map(r => r.data.street_with_type));
            let resultsToDelete = resultsSecondWord
              .filter(r => streetsFirstWord.has(r.data.street_with_type))
              .map(r => r.unrestricted_value);
            let resultsToSortUp = resultsFirstWord
              .filter(r => streetsSecondWord.has(r.data.street_with_type))
              .map(r => r.unrestricted_value);

            // Удаляем дубликаты
            data.suggestions = data.suggestions.filter(r => !resultsToDelete.includes(r.unrestricted_value));
            // Сортируем оригиналы вверх
            data.suggestions = data.suggestions.sort((a, b) =>
              resultsToSortUp.includes(a.unrestricted_value) === resultsToSortUp.includes(b.unrestricted_value) ? 0 : resultsToSortUp.includes(a.unrestricted_value) ? -1 : 1
            );
          }

          toAddressList.value = data.suggestions.filter(el => !((el.value == "Россия, г Челябинск") || (el.value == "Россия, г Екатеринбург")));
          if (toAddressList.value.length < 1) {
            toAddressList.value[0] = {disabled: "true", class: "disable-notice", value: "Нет результатов"};
          } else {
            toAddressList.value.unshift({disabled: "true", class: "disable-notice" ,value: "Выберите нужный адрес"});
          }
        } catch (e) {
          console.log(e);
        }
      }
    }

    // Создаем задержку запроса в 1 секунду
    const getFromAddressDebounce = debounce(getFromAddressList, 500)
    const getToAddressDebounce = debounce(getToAddressList, 500)

    const time = reactive({
      cargoPickup: {
        with: {
          start: WITH_START_TIME,
          end: "21:00",
        },
        before: {
          start: BEFORE_START_TIME,
          end: "24:00",
        },
        isDayToDay: false,
      },
      cargoDelivery: {
        with: {
          start: WITH_START_TIME,
          end: "21:00",
        },
        before: {
          start: BEFORE_START_TIME,
          end: "24:00",
        },
        isDayToDay: false,
      },
      step: "00:10",
      // applicationTimeIsOver: "13:00",
    });

    function changeDate(stateName) {
      changeStartTime(stateName);
      if(dataForm.cargoInformation.cargoSpaceType == 'simple') {
        refreshTimePickup();

      } else {
        tabRefreshTimePickup();
      }
    }

    function changeStartTime(stateName) {
      const timeName = getTimeName(stateName);
      time[timeName].with.start = WITH_START_TIME;
      time[timeName].before.start = BEFORE_START_TIME;

      time[timeName].isDayToDay = checkDayToDay(
        dataForm.applicationCargoPickup[stateName]
      );

      if (!time[timeName].isDayToDay) {
        return;
      }
      if (
        (dataForm.sender.cityFrom === "Челябинск" ||
          dataForm.sender.cityFrom === "Екатеринбург") &&
        new Date().getHours() >= 12 &&
        dataForm.cargoInformation.cargoWeight > 30
      ) {
        dataForm.cargoInformation.cargoWeight = 30;
      }

      const currentTime = roundUpTheTime(getStringCurrentTime());

      time[timeName].with.start =
        getStringCurrentTime() > time[timeName].with.start
          ? currentTime
          : WITH_START_TIME;

      const timeWithInterval = checkTimeInterval(time[timeName].with.start);
      time[timeName].before.start = timeWithInterval;

      dataForm.applicationCargoPickup[getEndTimeName(stateName)] = !dataForm
        .applicationCargoPickup[getEndTimeName(stateName)].length
        ? dataForm.applicationCargoPickup[getEndTimeName(stateName)]
        : timeWithInterval;
      const startTimeName = getStartTimeName(stateName);
      if (!dataForm.applicationCargoPickup[startTimeName].length) {
        return;
      }
      dataForm.applicationCargoPickup[startTimeName] = currentTime;
    }

    // const checkDayToDay = (stateName) => {
    //   const selectedDay = new Date(getStringDate(dataForm.applicationCargoPickup[stateName]));
    //   selectedDay.setDate(selectedDay.getDate() + 1);
    //   return getStringDate(new Date()) === getStringDate(selectedDay);
    // };

    // const getStringDate = (date) => date.toISOString().slice(0, 10);

    function roundUpTheTime(time) {
      const hoursNumber = Number(time.slice(0, 2));
      let minutes = Math.ceil(Number(time.slice(3, 5)) / 10) * 10;
      let hour = hoursNumber;
      if (minutes === 60) {
        hour++;
        minutes = 0;
      }

      return `${parseDate(hour)}:${parseDate(minutes)}`;
    }

    function compareTimes(time1, time2) {
      const date1 = new Date(`1970-01-01T${time1}:00`);
      const date2 = new Date(`1970-01-01T${time2}:00`);
      const isGreaterOrEqual = date1.getTime() >= date2.getTime();

      return isGreaterOrEqual;
  }

    const isApplicationTimeIsOver = () => {
      // getStringCurrentTime() >= time.applicationTimeIsOver;
      return compareTimes(getStringCurrentTime(), dataForm.getApplicationTimeIsOver);
    }

    function getStringCurrentTime() {
      const date = new Date();
      const hour = date.getHours();
      const minutes = date.getMinutes();

      return `${parseDate(hour)}:${parseDate(minutes)}`;
    }

    function changeStartTimeBefore(stateName) {
      const endTimeName = stateName.replace("Start", "End");
      const timeFromTheInterval = checkTimeInterval(
        dataForm.applicationCargoPickup[stateName]
      );

      const timeName = getTimeName(stateName);

      time[timeName].before.start =
        timeFromTheInterval.length > 3
          ? timeFromTheInterval
          : BEFORE_START_TIME;

      if (
        dataForm.applicationCargoPickup[endTimeName].length &&
        dataForm.applicationCargoPickup[endTimeName] < timeFromTheInterval
      ) {
        dataForm.applicationCargoPickup[endTimeName] = timeFromTheInterval;
      }
    }

    function checkIncludingLunch(stateName) {
      if (
        !dataForm.applicationCargoPickup[getStartTimeLunchName(stateName)]
          .length &&
        !dataForm.applicationCargoPickup[getEndTimeLunchName(stateName)].length
      ) {
        return;
      }
      includingLunch(getEndTimeLunchName(stateName));
    }

    function includingLunch(stateName) {
      const startTimeLunchName = stateName.replace("end", "start");
      const startTimeName = getStartTimeName(stateName);
      const endTimeName = getEndTimeName(stateName);

      if (
        !dataForm.applicationCargoPickup[startTimeLunchName].length ||
        (!dataForm.applicationCargoPickup[startTimeName] &&
          !dataForm.applicationCargoPickup[endTimeName])
      ) {
        return;
      }

      if (
        checkTimeLunchIn(startTimeName, endTimeName, startTimeLunchName) ||
        checkTimeLunchOut(
          startTimeName,
          endTimeName,
          startTimeLunchName,
          stateName
        )
      ) {
        const hours = 3;
        const cargoEndTime = `${parseDate(
          getHoursNumber(dataForm.applicationCargoPickup[stateName]) + hours
        )}:${dataForm.applicationCargoPickup[stateName].slice(3, 5)}`;
        const provenCargoEndTime =
          cargoEndTime > "24:00" ||
          dataForm.applicationCargoPickup[endTimeName] === "00:00"
            ? dataForm.applicationCargoPickup[endTimeName]
            : cargoEndTime === "24:00"
            ? "00:00"
            : cargoEndTime;

        if (
          dataForm.applicationCargoPickup[endTimeName].length &&
          dataForm.applicationCargoPickup[startTimeName].length
        ) {
          dataForm.applicationCargoPickup[endTimeName] =
            dataForm.applicationCargoPickup[endTimeName] > provenCargoEndTime
              ? dataForm.applicationCargoPickup[endTimeName]
              : provenCargoEndTime;
          return;
        }
      }
    }

    const getHoursNumber = (time) => Number(time.slice(0, 2));

    const getTimeName = (stateName) =>
      stateName.toLowerCase().indexOf("delivery") >= 0
        ? "cargoDelivery"
        : "cargoPickup";

    const getStartTimeName = (stateName) =>
      stateName.indexOf("Delivery") >= 0
        ? "cargoStartTimeDelivery"
        : "cargoStartTimePickup";

    const getEndTimeName = (stateName) =>
      stateName.toLowerCase().indexOf("delivery") >= 0
        ? "cargoEndTimeDelivery"
        : "cargoEndTimePickup";

    const getStartTimeLunchName = (stateName) =>
      stateName.indexOf("Delivery") >= 0
        ? "startTimeLunchBreakDelivery"
        : "startTimeLunchBreak";

    const getEndTimeLunchName = (stateName) =>
      stateName.indexOf("Delivery") >= 0
        ? "endTimeLunchBreakDelivery"
        : "endTimeLunchBreak";

    const checkTimeLunchIn = (startTimeName, endTimeName, startTimeLunchName) =>
      dataForm.applicationCargoPickup[startTimeName] <=
        dataForm.applicationCargoPickup[startTimeLunchName] &&
      dataForm.applicationCargoPickup[endTimeName] >
        dataForm.applicationCargoPickup[startTimeLunchName];

    const checkTimeLunchOut = (
      startTimeName,
      endTimeName,
      startTimeLunchName,
      endTimeLunchName
    ) =>
      dataForm.applicationCargoPickup[startTimeName] >
        dataForm.applicationCargoPickup[startTimeLunchName] &&
      dataForm.applicationCargoPickup[startTimeName] <
        dataForm.applicationCargoPickup[endTimeLunchName];

    function checkTimeInterval(time) {
      const timeHour = Number(time.slice(0, 2)) + 3;
      const timeMinute = time.slice(3, 5);

      return `${parseDate(timeHour)}:${timeMinute}`;
    }

    const checkCity = () =>
      dataForm.sender.cityFrom === "Челябинск" ||
      dataForm.sender.cityFrom === "Екатеринбург";

    const checkHour = () => new Date().getHours() >= 12;

    let fromAddresstimeout = null;
    const getFromAddressSearch = (queryString, cb) => {
      
      // call callback function to return suggestions
      clearTimeout(fromAddresstimeout)
      fromAddresstimeout = setTimeout(() => {cb(fromAddressList.value)}, 500)
    }

    let toAddresstimeout = null;
    const getToAddressSearch = (queryString, cb) => {
      
      // call callback function to return suggestions
      clearTimeout(toAddresstimeout)
      toAddresstimeout = setTimeout(() => {cb(toAddressList.value)}, 500)
    }

    watch(
      () => dataForm.isSpecialClient,
      (isSpecial) => {
        dataForm.updateApplicationTimeIsOver();
        
        if(dataForm.cargoInformation.cargoSpaceType == 'simple') {
          refreshTimePickup();
        } else {
          tabRefreshTimePickup();
        }

        if (!isSpecial && dataForm.applicationCargoPickup.pickupDate) {
          const selected = new Date(dataForm.applicationCargoPickup.pickupDate);
          selected.setHours(0, 0, 0, 0);

          const today = new Date();
          today.setDate(isApplicationTimeIsOver() ? today.getDate() : today.getDate() - 1);
          today.setHours(0, 0, 0, 0);

          if (selected < today || selected.getDay() === SUNDAY) {
            dataForm.applicationCargoPickup.pickupDate = "";
          }
        }
      }
    );

    return {
      dataForm,
      options,
      time,
      getFromAddressSearch,
      getToAddressSearch,
      optionsTypePowerOfAttorney,
      getArrayOfRules,
      checkDayToDay,
      checkCity,
      checkHour,
      cargoPickupChange: function () {
        if (document.querySelector(".calculator__title")) {
          if(dataForm.applicationCargoPickup.isCargoPickup){
            document.querySelector(".calculator__title").innerHTML = "Оформление заявки на забор груза"
          } else {
            document.querySelector(".calculator__title").innerHTML = "Оформление экспедиторской расписки перед отправкой"
          }
        }
      },
      cargoPickupSwitchTo(){
        return blockPickupSwitch('to');
      },

      cargoPickupSwitchFrom() {
        return blockPickupSwitch('from');
      },

      addressFromDropdown,
      addressToDropdown,
      changeDate,
      includingLunch,
      checkCityRoadTo, 
      checkCityRoadFrom,

      changeStartTime: function (stateName) {
        changeStartTimeBefore(stateName);
        checkIncludingLunch(stateName);
      },

      changeEndTime: function (stateName) {
        checkIncludingLunch(stateName);
      },

      chengeTimeLunch: function (stateName) {
        includingLunch(stateName);
      },

      datePickerOptions: function (date) {
        const today = new Date();

        today.setDate(
          isApplicationTimeIsOver() ? today.getDate() : today.getDate() - 1
        );

        return date < today || (!dataForm.isSpecialClient && date.getDay() === SUNDAY);
      },

      fromAddressList,
      toAddressList,

      getFromAddress: function () {
        dataForm.applicationCargoPickup.addressSelected = false;
        getFromAddressDebounce(dataForm.applicationCargoPickup.addressCargoPickup, dataForm.sender.cityFrom)  
      },
      getToAddress: function () {
        dataForm.applicationCargoPickup.addressSelectedTo = false;
        getToAddressDebounce(dataForm.applicationCargoPickup.addressConsignee, dataForm.consignee.cityTo)
      },
      cargoPickupStartTime: () => {
        return checkTimeInterval(time.cargoPickup.with.end);
      },

      cargoDeliveryStartTime: () => {
        return checkTimeInterval(time.cargoDelivery.with.end);
      },
    };
  },
};
